import { render, staticRenderFns } from "./UserPageServerError.vue?vue&type=template&id=155795e1&scoped=true"
import script from "./UserPageServerError.vue?vue&type=script&lang=js"
export * from "./UserPageServerError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155795e1",
  null
  
)

export default component.exports